import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Section } from '../fx/AccentContext';
import { MaskedLines } from '../fx/MaskedLines';
import { SectionLabel, PADX } from '../home/ui';
import { EASE_EXPO } from '../fx/ease';

/**
 * サブページ共通のイントロ。ラベル + Anton巨大見出し（文字リビール）+ JPリード。
 * title: string[]（行配列・英字のみ） / lead: MaskedLines互換のlines
 * accent: ページ先頭からそのページのアクセント色を効かせる（レールの母数には数えない）
 */
export default function PageIntro({
  label,
  no = null,
  title,
  titleClassName = 'display-type mt-8 text-[13vw] text-ink sm:text-8xl lg:text-[7.5vw] 2xl:text-[120px]',
  titlePer = 'char',
  lead,
  accent = 'blue',
  children,
  className = '',
}) {
  const reduce = useReducedMotion();
  return (
    <Section
      index={0}
      accent={accent}
      counted={false}
      className={`${PADX} border-b border-line pb-14 pt-32 md:pb-20 md:pt-44 ${className}`}
    >
      <SectionLabel no={no}>{label}</SectionLabel>
      <MaskedLines
        as="h1"
        per={titlePer}
        lines={title}
        className={titleClassName}
        stagger={0.12}
        margin="0px"
      />
      {lead && (
        <MaskedLines
          lines={lead}
          className="mt-8 max-w-[42em] text-[15px] font-medium leading-[1.9] tracking-display-ja text-gray-700 md:text-[16px]"
          delay={0.35}
          margin="0px"
        />
      )}
      {children && (
        <motion.div
          initial={reduce ? false : { opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: EASE_EXPO, delay: 0.6 }}
          className="mt-10"
        >
          {children}
        </motion.div>
      )}
    </Section>
  );
}
